export const progressSteps = [
  { key: 'welcome', label: 'Welcome' },
  { key: 'cloudProviders', label: 'Cloud Providers' },
  { key: 'cloudEnvironments', label: 'Cloud Environments' },
  { key: 'multicloudDrivers', label: 'Multicloud Drivers' },
  { key: 'industry', label: 'Industry' },
  { key: 'userScale', label: 'User Scale' },
  { key: 'geography', label: 'User Locations' },
  { key: 'strategicGoals', label: 'Strategic Goals' },
  { key: 'headquarter', label: 'Headquarters' },
  { key: 'contact', label: 'Contact Info' },
];

export const welcomeHighlights = [
  { title: 'Quick Assessment', description: 'Complete in less than 10 minutes', image: 'quick-assessment.png' },
  {
    title: 'Expert Insights',
    description:
      'Based on a {global survey|https://www.equinix.com/resources/whitepapers/hybrid-multicloud-networking-global-research} of 1,643 senior IT leaders',
    image: 'expert-insights.png',
  },
  { title: 'Custom Report', description: 'Downloadable strategy design recommendations', image: 'custom-report.png' },
  { title: 'Tailored Guidance', description: 'Address hybrid multicloud challenges', image: 'tailored-guidance.png' },
];

export const cloudEnvironmentOptions = [
  { label: 'Amazon Web Services (AWS)', value: 'aws', badge: 'AWS' },
  { label: 'Microsoft Azure', value: 'azure', badge: 'AZ' },
  { label: 'Google Cloud', value: 'gcp', badge: 'GCP' },
  { label: 'Oracle Cloud', value: 'oracle', badge: 'OCI' },
  { label: 'Other IaaS and PaaS clouds', value: 'iaas' },
  { label: 'Other SaaS clouds', value: 'saas' },
  { label: 'Industry-specific cloud services', value: 'industry' },
  { label: 'Regional/local cloud services', value: 'regional' },
];

export const multicloudDriverOptions = [
  { label: 'Productivity', value: 'productivity' },
  { label: 'Security', value: 'security' },
  { label: 'Scalability', value: 'scalability' },
  { label: 'AI enablement', value: 'ai' },
  { label: 'Cost optimization', value: 'cost' },
];

export const industryOptions = [
  { label: 'Financial Services (Banking, Capital Markets, Insurance, Fintech)', value: 'financial-services' },
  { label: 'Healthcare and Life Sciences', value: 'healthcare' },
  { label: 'Technology and Professional Services', value: 'technology' },
  { label: 'Manufacturing and Industrial', value: 'manufacturing' },
  { label: 'Retail and Consumer Services', value: 'retail' },
  { label: 'Media and Entertainment', value: 'media' },
  { label: 'Energy and Utilities', value: 'energy' },
  { label: 'Public Sector and Government', value: 'public-sector' },
  { label: 'Cloud and IT Services', value: 'cloud' },
  { label: 'Network Services', value: 'network' },
  { label: 'Other', value: 'other' },
];

export const userScaleOptions = [
  { label: 'Less than 1,000', value: 'under-1k' },
  { label: '1,000 - 10,000', value: '1k-10k' },
  { label: '10,001 - 50,000', value: '10k-50k' },
  { label: '50,001 - 100,000', value: '50k-100k' },
  { label: '100,001 - 1,000,000', value: '100k-1m' },
  { label: '1,000,001 - 10,000,000', value: '1m-10m' },
  { label: 'More than 10,000,000', value: 'over-10m' },
];

export const regionOptions = [
  { label: 'Canada', value: 'CN' },
  { label: 'US East', value: 'USE' },
  { label: 'US West', value: 'USW' },
  { label: 'US Central', value: 'USC' },
  { label: 'LATAM', value: 'LATAM' },
  { label: 'Mexico', value: 'MX' },
  { label: 'Continental Europe', value: 'EU' },
  { label: 'UK & Ireland', value: 'UK' },
  { label: 'Middle East', value: 'ME' },
  { label: 'Africa', value: 'AF' },
  { label: 'China', value: 'CH' },
  { label: 'Japan', value: 'JP' },
  { label: 'India', value: 'IN' },
  { label: 'Southeast Asia', value: 'SA' },
  { label: 'Australia & Oceania', value: 'OS' },
];

export const strategicGoalOptions = [
  { label: 'Enhancing security and compliance', value: 'security-compliance' },
  { label: 'Supporting AI and ML initiatives', value: 'ai-ml' },
  { label: 'Improving scalability and future-proofing', value: 'scale-future' },
  { label: 'Improving developer productivity', value: 'developer-productivity' },
  { label: 'Reducing infrastructure costs', value: 'cost-reduction' },
  { label: 'Expanding to new geographies', value: 'expansion' },
  { label: 'Improving sustainability efforts', value: 'sustainability' },
  { label: 'Choosing key ecosystem partners', value: 'ecosystem' },
];

const defaultRegions = {
  highest: '',
  high: [],
  emerging: [],
};

const defaultFormState = {
  providerCount: 0,
  cloudEnvironments: [],
  factors: [],
  ecosystemDensity: '',
  userScale: '',
  regions: defaultRegions,
  strategicGoals: [],
  headquarter: '',
  contactFirstName: '',
  contactName: '',
  contactJobTitle: '',
  contactEmail: '',
  contactCompany: '',
  contactCountry: '',
  contactComments: '',
  consent: false,
};

export const createInitialFormState = () => ({
  ...defaultFormState,
  regions: { ...defaultRegions },
});

export const benchmarkModalByStep = {
  cloudProviders: 'providers',
  cloudEnvironments: 'adoptionTrends',
  multicloudDrivers: 'driversAnalysis',
  geography: 'geographyInsights',
  strategicGoals: 'strategicGoals',
};

export const averageProviderCount = 36;

export const driverStats = [
  { label: 'Scalability', value: 54, key: 'scalability' },
  { label: 'Productivity', value: 48, key: 'productivity' },
  { label: 'Cost', value: 47, key: 'cost' },
  { label: 'Security', value: 45, key: 'security' },
  { label: 'AI', value: 45, key: 'ai' },
];

export const strategicGoalStats = [
  { label: 'Enhancing security and compliance', value: 64, key: 'security-compliance' },
  { label: 'Supporting AI and ML initiatives', value: 59, key: 'ai-ml' },
  { label: 'Improving scalability and future-proofing', value: 56, key: 'scale-future' },
  { label: 'Improving developer productivity', value: 52, key: 'developer-productivity' },
  { label: 'Reducing infrastructure costs', value: 47, key: 'cost-reduction' },
  { label: 'Expanding to new geographies', value: 46, key: 'expansion' },
  { label: 'Improving sustainability efforts', value: 38, key: 'sustainability' },
  { label: 'Choosing key ecosystem partners', value: 26, key: 'ecosystem' },
];

export const adoptionTrendStats = [
  { label: 'Data & Analytics', value: 72 },
  { label: 'Enterprise Workloads', value: 62 },
  { label: 'Customer Apps', value: 58 },
  { label: 'DevOps', value: 52 },
];
